import {httpProvider}           from "./httpProvider.config";
import {locationProviderConfig} from "./locationProvider.config";
import {stateProviderConfig}    from "./stateProvider.config";
import {upreachPaletteProvider} from "./upreachPaletteProvider.config";
import resourceProviderConfig from "./resourceProvider.config";
//import {modalProvider}          from "./modalProvider.config";

const api = {
	"Login": "/api/rest-auth/login/",
	"Logout": "/api/rest-auth/logout/",
	"Configurations": "/api/configurations/",
	"Deployments": "/api/deployments/",
	"TwoFactor": "/api/rest-auth/enable-2fa/"
};

export const ConfigsModule = angular
	.module("app.configs", [])
	.constant({
		"CONFIG": {
			"API": api,
			"ContentType": "application/json"
		}
	})
	.config(httpProvider)
	.config(locationProviderConfig)
	.config(stateProviderConfig)
	.config(upreachPaletteProvider)
    .config(resourceProviderConfig);
	//.config(modalProvider);



// WEBPACK FOOTER //
// ./sources/config/config.js